import { Component, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

import { DataService } from '../../../services/data.service';

import { AppComponentGenericComponent } from '../../custom/app-component-generic/app-component-generic.component';

import { GenericFilterParameter } from '../../../models/generic-comunication-cmp';
import { GenericExternalCommandType } from '../../../models/generic-external-command';
import { RendicontazioneTableField } from '../../../models/rendicontazione-table-field';
import { GenericTableField } from '../../../models/generic-table-field';
import { rendicontazioneGeneraleType } from '../../../models/rendicontazione';

@Component({
	selector: 'app-rendicontazione-generale',
	templateUrl: './rendicontazione-generale.component.html',
	styleUrls: ['./rendicontazione-generale.component.css']
})
export class RendicontazioneGeneraleComponent extends AppComponentGenericComponent implements OnInit {
	@ViewChild('mw') mw: any;

    filterMap = null;
	rendicontazioniMap: Map<string, Map<string, rendicontazioneGeneraleType>> = new Map();
	rendicontazioniFiltered: rendicontazioneGeneraleType[] = [];
	rendicontazioniFilteredSubmit: any[] = [];
	rendicontazioneTotal: rendicontazioneGeneraleType;

	pagamentiFiltered: any[] = [];
	pagamentiSync: Subscription;

	emissioniSync: Subscription;
	emissioniSelected: any[];

	parametriString: string = "{}";
	parametri: GenericFilterParameter = null;

	externCommands: Map<string, GenericExternalCommandType> = null;

	tableFields: RendicontazioneTableField;
    headerFields: GenericTableField[];
    footerFields: GenericTableField[];
    /*headerFields = [
	{
		label: "Emissione",
		code: "emissione",
		type: "label",
		class: "tab-cell-15 text-left"
	},
	{
		label: "Canale",
		code: "canale",
		type: "label",
		class: "tab-cell-15 text-left"
	},
	{
		label: "Riscosso",
		code: "pagato",
		type: "label",
		class: "tab-cell-10 text-center"
	},
	{
		label: "Debito",
		code: "debito",
		type: "label",
		class: "tab-cell-8 text-center"
	},
	{
		label: "Sp. Not.",
		code: "notificaSpese",
		type: "label",
		class: "tab-cell-8 text-center"
	},
	{
		label: "Oneri",
		code: "oneri",
		type: "label",
		class: "tab-cell-8 text-center"
	},
	{
		label: "Altro",
		code: "altro",
		type: "label",
		class: "tab-cell-8 text-center"
	},
	{
		label: "Aggio",
		code: "aggio",
		type: "label",
		class: "tab-cell-8 text-center"
	},
	{
		label: "Pagamenti interi",
		code: "numeroInteri",
		type: "label",
		class: "tab-cell-10 text-center"
	},
	{
		label: "Pagamenti a rate",
		code: "numeroRate",
		type: "label",
		class: "tab-cell-10 text-center"
	},
    ];

	footerFields = [];*/

    ngClassRow = "\"\""

	modalInput: any = {
		size: 'large-modal',
		title: 'Titolo',
		subtitle: 'sottotitolo',
		data: {
			pagamenti: [],
		}
	}

	constructor(protected dataService: DataService) {
		super(dataService, 'statistiche-rendicontazione');
	}

	ngOnInit() {
		this.tableFields = new RendicontazioneTableField();
		this.headerFields = this.tableFields.getHeader();
		this.footerFields = this.tableFields.getFooter();
		this.externCommands = new Map();
		this.parametri = new GenericFilterParameter();
		this.parametri.setTypeFilter("rendicontazione-generale");
		this.parametri.setTitleBox("Rendicontazione Generale");
		this.parametri.setNumFilteredTxt("Righe");
		this.parametri.setWritePermission(this.checkPermission('statistiche-rendicontazione','write'));

		if(this.checkPermission('statistiche-rendicontazione','write')){
			let externCommandLocal = new GenericExternalCommandType();
			externCommandLocal.setAllValue("rendicontazione-analitico", "description", "analitic", "Analitico", false);
			this.externCommands.set('analitic', externCommandLocal);

			externCommandLocal = new GenericExternalCommandType();
			externCommandLocal.setAllValue("rendicontazione-dettaglio", "details", "detail", "Dettaglio", false);
			this.externCommands.set('detail', externCommandLocal);

			let esportaPraticheCommand = new GenericExternalCommandType();
			esportaPraticheCommand.setAllValue("", "cloud_download", "esporta-rendicontazioni", "Esporta Rendicontazioni", false);
			this.externCommands.set('esporta-rendicontazioni', esportaPraticheCommand);
		}
		this.parametri.setExternCommands(this.externCommands);
		this.updateParametri();

		this.emissioniSelected = [];
		this.emissioniSync = this.dataService.emissioni$.subscribe(
			emissioni => {
				this.parametri.setEmissioni(emissioni);
				this.updateParametri();
			});
		this.pagamentiSync = this.dataService.pagamenti$.subscribe(
			pagamenti => {
				this.parametri.setDataArraySource(pagamenti);
				this.updateParametri();
			});
	}

	checkEsisteRendicontazioneMap(emissione: any, canale: any, rendicontazioneGenerale: rendicontazioneGeneraleType){
		//console.log("rendicontazioneGenerale aggregaRendicondazioneMap '", emissione, "' '",canale, "'");

		if(this.rendicontazioniMap.has(emissione)){
			//console.log("rendicontazioneGenerale si emissione");
			if(this.rendicontazioniMap.get(emissione).has(canale)){
				//console.log("rendicontazioneGenerale si canale");
			}else{
				//console.log("rendicontazioneGenerale no canale");
				rendicontazioneGenerale.setFieldValue("emissione", emissione);
				rendicontazioneGenerale.setFieldValue("canale", canale);
				//console.log("rendicontazioneGenerale", rendicontazioneGenerale);
				this.rendicontazioniMap.get(emissione).set(canale, rendicontazioneGenerale);
			}
		}else{
			//console.log("rendicontazioneGenerale no emissione");
			//console.log("rendicontazioneGenerale no canale");
			rendicontazioneGenerale.setFieldValue("emissione", emissione);
			rendicontazioneGenerale.setFieldValue("canale", canale);
			this.rendicontazioniMap.set(emissione, new Map())
			this.rendicontazioniMap.get(emissione).set(canale, rendicontazioneGenerale);
		}
	}

	aggregaRendicondazioneMap(pagamento: any, praticaObject: any){
		//console.log("rendicontazioneGenerale", "pagamento", pagamento, "praticaObject", praticaObject);
		let emissione = pagamento.emissione;
		let canale = pagamento.canale;
		let rendicontazioneGenerale = new rendicontazioneGeneraleType(this.dataService.getCommon().getLocale());
		this.checkEsisteRendicontazioneMap(emissione, canale, rendicontazioneGenerale);

		let singleRendicontazione = this.rendicontazioniMap.get(emissione).get(canale);
		let pagatoTemp = Number(singleRendicontazione.getFieldValue("pagato"));
		singleRendicontazione.setFieldValue("pagato", pagatoTemp + parseFloat(pagamento.sommaPagata));

		if(pagamento.rifRata != 0){
			let numeroRateTemp = Number(singleRendicontazione.getFieldValue("numeroRate"));
			singleRendicontazione.setFieldValue("numeroRate", numeroRateTemp + 1);
			//console.log("rendicontazioneGenerale non rifRata", pagamento, pagamento.rifRata);
		}else{
			let numeroInteriTemp = Number(singleRendicontazione.getFieldValue("numeroInteri"));
			singleRendicontazione.setFieldValue("numeroInteri", numeroInteriTemp + 1);
			//console.log("rendicontazioneGenerale zero rifRata", pagamento, pagamento.rifRata);
		}
		//console.log("rendicontazioneGenerale", rendicontazioneGenerale, praticaObject);
		if(praticaObject && praticaObject["pratica"] && praticaObject["dettagli"]){
			let pratica = praticaObject["pratica"];
			let dettagli = praticaObject["dettagli"];
			let local_totale = pratica["totale_dovuto"];
			let local_pagato = Number(singleRendicontazione.getFieldValue("pagato"));
			let local_dovuto = 0.00;
			let local_aggio = 0.00;
			let local_oneri = 0.00;
			let local_altro = 0.00;
			let local_arr = 0.00;
			let local_notifica_spese = parseFloat(pratica["notifica_spese_agg"]) + parseFloat(pratica["notifica_spese_agg_prec"]);
			if(local_notifica_spese <= local_pagato){
				local_notifica_spese = local_notifica_spese;
			}else{
				local_notifica_spese = local_pagato;
			}
			local_altro += parseFloat(pratica["spese_esecutive"]) + parseFloat(pratica["spese_giudiziali"]);
			//console.log("local_altro", local_altro, parseFloat(pratica["diritti_pf_agg"]), parseFloat(pratica["diritti_pf_agg_prec"]))
			local_altro += parseFloat(pratica["diritti_pf_agg"]) + parseFloat(pratica["diritti_pf_agg_prec"]);
			//console.log("rendicontazioneGenerale local_totale", local_totale);
			local_totale -= local_notifica_spese;
			local_pagato -= local_notifica_spese;

			dettagli.forEach((value: any, key: any) => {
				local_dovuto += parseFloat(value["dovuto"]) - parseFloat(value["versato"] + parseFloat(value["arrotondamento"]));
				local_oneri += parseFloat(value["oneri_risc_attuali"]);
				local_altro += parseFloat(value["sanzioni"]) + parseFloat(value["interessi"]) + parseFloat(value["notifica_spese"]);
				local_altro += parseFloat(value["sanzioni_agg"]) + parseFloat(value["sanzioni_agg_prec"]);
				local_altro += parseFloat(value["interessi_agg"]) + parseFloat(value["interessi_agg_prec"]);
			});
			local_dovuto = (local_dovuto * local_pagato) / local_totale;
			local_oneri = (local_oneri * local_pagato) / local_totale;
			local_altro = (local_altro * local_pagato) / local_totale;
			local_aggio = (local_pagato - local_notifica_spese - local_oneri)*0.33;
			local_arr = parseFloat(local_pagato.toFixed(2)) - (parseFloat(local_dovuto.toFixed(2)) + parseFloat(local_oneri.toFixed(2)) + parseFloat(local_altro.toFixed(2)));
			local_dovuto += local_arr;

			singleRendicontazione.setFieldValue("debito", local_dovuto);
			singleRendicontazione.setFieldValue("notificaSpese", local_notifica_spese);
			singleRendicontazione.setFieldValue("oneri", local_oneri);
			singleRendicontazione.setFieldValue("altro",local_altro);
			singleRendicontazione.setFieldValue("aggio", local_aggio);
		}
	}

	compilaRendicontazione(){
		this.rendicontazioniFiltered = [];
		this.rendicontazioniFilteredSubmit = [];
		this.rendicontazioniMap.clear();
		let emissione = "";
		let canale = "";

		if(this.pagamentiFiltered){
			for(let pagamento of this.pagamentiFiltered){
				let praticaObject = {};
				this.dataService.getPraticaById(pagamento["uid"], (localPratica) => {
					praticaObject["pratica"] = localPratica;
				});
				this.dataService.getDettagliByUid(pagamento["uid"], (localDettagli) => {
					praticaObject["dettagli"] = localDettagli;
				});
				this.aggregaRendicondazioneMap(pagamento, praticaObject);
			}
		}
		//console.log("rendicontazioniMap rendicontazioniMap", this.rendicontazioniMap);
		this.rendicontazioniMap.forEach((emissioneValue: Map<string, rendicontazioneGeneraleType>, emissione: string, rendicontazioniMap: Map<string, Map<string, rendicontazioneGeneraleType>>) => {
			//console.log("rendicontazioniMap emissione", emissione, emissioneValue);
			emissioneValue.forEach((canaleValue: rendicontazioneGeneraleType, canale: string) => {
				//console.log("rendicontazioniMap canale", canale, canaleValue);
				let rendicontazione = new rendicontazioneGeneraleType(this.dataService.getCommon().getLocale());
				rendicontazione.setFieldValue("emissione", emissione);
				rendicontazione.setFieldValue("canale", canale);
				rendicontazione.setFieldValue("pagato", canaleValue.getFieldValue("pagato"));
				rendicontazione.setFieldValue("debito", canaleValue.getFieldValue("debito"));
				rendicontazione.setFieldValue("notificaSpese", canaleValue.getFieldValue("notificaSpese"));
				rendicontazione.setFieldValue("oneri", canaleValue.getFieldValue("oneri"));
				rendicontazione.setFieldValue("altro", canaleValue.getFieldValue("altro"));
				rendicontazione.setFieldValue("aggio", canaleValue.getFieldValue("aggio"));
				rendicontazione.setFieldValue("numeroInteri", canaleValue.getFieldValue("numeroInteri"));
				rendicontazione.setFieldValue("numeroRate", canaleValue.getFieldValue("numeroRate"));
				//console.log("rendicontazioneGenerale rendicontazione", rendicontazione);
				this.rendicontazioniFiltered.push(rendicontazione);

				let rendicontazioneSubmit = {};
				rendicontazioneSubmit["emissione"] = emissione;
				rendicontazioneSubmit["canale"] = canale;
				rendicontazioneSubmit["pagato"] = canaleValue.getFieldString("pagato");
				rendicontazioneSubmit["debito"] = canaleValue.getFieldString("debito");
				rendicontazioneSubmit["notificaSpese"] = canaleValue.getFieldString("notificaSpese");
				rendicontazioneSubmit["oneri"] = canaleValue.getFieldString("oneri");
				rendicontazioneSubmit["altro"] = canaleValue.getFieldString("altro");
				rendicontazioneSubmit["aggio"] = canaleValue.getFieldString("aggio");
				rendicontazioneSubmit["numeroInteri"] = canaleValue.getFieldString("numeroInteri");
				rendicontazioneSubmit["numeroRate"] = canaleValue.getFieldString("numeroRate");
				//console.log("rendicontazioneGenerale rendicontazioneSubmit", rendicontazioneSubmit);
				this.rendicontazioniFilteredSubmit.push(rendicontazioneSubmit);
			});
		});
		//console.log("rendicontazioneGenerale filtered", this.rendicontazioniFiltered);
		this.riempiRendicontazioneTotal(this.rendicontazioniFiltered);
	}

	riempiRendicontazioneTotal(rendicontazioneGenerale: rendicontazioneGeneraleType[]){
		this.rendicontazioneTotal = new rendicontazioneGeneraleType(this.dataService.getCommon().getLocale());

		this.rendicontazioneTotal.getMap().forEach((value, key, map) => {
			//console.log("rendicontazioneGenerale pre", value, key, rendicontazioneGenerale);
			this.rendicontazioneTotal.clearField(key);
			let headerFieldType = this.rendicontazioneTotal.getFieldType(key);
			if(headerFieldType == 'number' || headerFieldType == 'currency'){
				let totalValue = rendicontazioneGenerale.reduce(
					(prevVal, elem) => {
						let actVal = Number(elem.getFieldValue(key));
						//console.log("rendicontazioneGenerale reduce", prevVal, typeof(prevVal), "---!", actVal , "!---", typeof(actVal));
						return prevVal + actVal;
					}
				, 0.00);
				this.rendicontazioneTotal.setFieldValue(key, totalValue);
			}
		});
		this.tableFields.generateFooterRow(this.rendicontazioneTotal);
		this.footerFields = this.tableFields.getFooter();
	}

	/*generateFooterRow(){
		this.footerFields = [];
		let totalField: any;
		//console.log("rendicontazioneTotal", this.rendicontazioneTotal);
		for(let headerField of this.headerFields){
			totalField = {};
			totalField["code"] = headerField["code"];
			totalField["class"] = headerField["class"];
			totalField["value"] = this.rendicontazioneTotal.getFieldString(headerField["code"]);
			this.footerFields.push(totalField);
		}
		//console.log("totalFields", this.footerFields);
    }*/

	updateParametri(){
		//console.log('CHANGE RENDICONTAZIONE-GENERALE-BOX UPDATEPARAMETRI', this.parametri);
		this.parametriString = this.parametri.generateParametriToString();
		//console.log('CHANGE RENDICONTAZIONE-GENERALE-BOX UPDATEPARAMETRISTRING', this.parametriString);
	}

    manageEventFilterBox($event){
		console.log("manageEventFilterBox", $event);
		if($event){
			switch($event.type){
				case 'filterResult':
					this.pagamentiFiltered = $event.data;
					this.filterMap = $event.filterMap;
					this.emissioniSelected = this.parametri["emissioni"];
					//console.log("manageEventFilterBox filterMap pre", this.filterMap, this.emissioniSelected);
					if(this.filterMap){
						if(this.filterMap.get('emissioniSelected')){
							if(this.filterMap.get('emissioniSelected')['value']){
								if(this.filterMap.get('emissioniSelected')['value'].length){
									this.emissioniSelected = this.filterMap.get('emissioniSelected')['value'];
								}
							}
						}
					}
					this.compilaRendicontazione();
					break;
				case 'action':
					let dataCommand = $event.data;
					let codeCommand = dataCommand.code;
					let typeCommand = dataCommand.type;
					let textCommand = dataCommand.text;
					switch(typeCommand) {
						case 'rendicontazione-analitico':
						case 'rendicontazione-dettaglio':
							this.modalInput = {
								size: 'large-modal',
								height: 'native',
								title: 'Rendicontazione ' + textCommand,
								subtitle: '',
								data: {
									pagamenti: this.pagamentiFiltered,
								}
							};
							break;
						case 'esporta-rendicontazioni':
							this.exportCsv();
							break;
					}
					if (codeCommand.length) {
						this.mw.show(codeCommand, this.modalInput);
					}
					break;
				default:
					console.log("type non riconosciuto!");
			}
		}
	}

	exportCsv() {
		let filename = "rendicontazioni";
		let data = [];
		for (let rendicontazione of this.rendicontazioniFilteredSubmit) {
			let item = {}
			item['Emissione'] = rendicontazione.emissione ? rendicontazione.emissione : "";
			item['Canale'] = rendicontazione.canale ? rendicontazione.canale : "";
			item['Riscosso'] = rendicontazione.pagato ? rendicontazione.pagato : "";
			item['Debito'] = rendicontazione.debito ? rendicontazione.debito : "";
			item['Spese Notifica'] = rendicontazione.notificaSpese ? rendicontazione.notificaSpese : "";
			item['Oneri'] = rendicontazione.oneri ? rendicontazione.oneri : "";
			item['Altro'] = rendicontazione.altro ? rendicontazione.altro : "";
			item['Aggio'] = rendicontazione.aggio ? rendicontazione.aggio : "";
			item['Parametri interi'] = rendicontazione.numeroInteri ? rendicontazione.numeroInteri : "";
			item['Parametri a rate'] = rendicontazione.numeroRate ? rendicontazione.numeroRate : "";
			data.push(item);
		}
		this.dataService.exportCsv(filename,data);
	}

	sendData(){
	}

	newItem(){
	}

	getModalOutput(event: any){
		console.debug('RENSDICONTAZIONE GENERALE|EVENT:', event);
	}

    ngOnDestroy() {
		this.emissioniSync.unsubscribe();
		this.pagamentiSync.unsubscribe();
    }
}
